import React, { useEffect, useState, useCallback } from "react";
import EkycLogs1 from "./EkycLogs1";
import EkycLogs2 from "./EkycLogs2";
import "./EkycLogs.css";

export default function EkycLogs() {
  const [activeTab, setActiveTab] = useState("EkycLogs1");

  return (
    <div className="ezlog-tabs-wrapper">
      <div className="ezlog-tabs-header">
        <button
          className={`ezlog-tab-btn ${
            activeTab === "EkycLogs1" ? "active" : ""
          }`}
          onClick={() => setActiveTab("aepslogs1")}
        >
          E-kyc Detail Validate Logs
        </button>
        <button
          className={`ezlog-tab-btn ${
            activeTab === "EkycLogs2" ? "active" : ""
          }`}
          onClick={() => setActiveTab("aepslogs2")}
        >
          E-kyc Biometrics Logs
        </button>
      </div>

      <div className="ezlog-tab-content">
        {activeTab === "EkycLogs1" ? <EkycLogs1 /> : <EkycLogs2 />}
      </div>
    </div>
  );
}
